import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Logout } from '../../../store/actions/AuthActions';
import { isAuthenticated } from '../../../store/selectors/AuthSelectors';
import nbrApi from '../../../services/nbrApi';


function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function LogoutPage(props) {
  const { compact = false } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedLoginData = useSelector(state => state.auth.loginData)
  const userData = useSelector(state => state.auth.userData)
  let selectedData = userData?.filter(e =>
    e?.properties_id === parseInt(selectedLoginData?.properties_id) &&
    e?.roles_id === Number(selectedLoginData?.role_id)
  )?.[0]

  function onLogout() {
    Swal.fire({
      title: 'Are you sure?',
      // text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      // cancelButtonColor: '#fff',
      confirmButtonText: 'Yes, log me out!',
    }).then((result) => {
      if (result.isConfirmed) {
        let payload = {
          resources_id: selectedData?.resources_id
        }
        nbrApi.post('/logout', payload)
          .then(response => {
            if (response.status === 200) {
              localStorage.removeItem('canShowCleaningBtn');

              dispatch(Logout(navigate));
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: `Logged out!`,
                text: 'You have been logged out successfully.',
                showConfirmButton: false,
                timer: 2000,
              })
            } else {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: `Error!`,
                text: 'Failed to log out. Please try again.',
                showConfirmButton: false,
                timer: 2000,
              })
            }
          })
          .catch(error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: `Error!`,
              text: 'Failed to log out. Please try again.',
              showConfirmButton: false,
              timer: 2000,
            })
          });
      }
    });
  }
  return (
    <>
      <button
        type="button"
        className={`dropdown-item ai-icon ${compact ? 'header-logout-btn--compact' : 'ms-1'}`}
        onClick={onLogout}
        aria-label="Logout"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
        {!compact && <span className="ms-2">Logout</span>}
      </button>
    </>
  )
}
const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

//export default LogoutPage;

export default withRouter(connect(mapStateToProps)(LogoutPage));